interface NumberInputProps {
  value?: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  [otherProps: string]: any;
}

function NumberInput({ value, onChange, ...otherProps }: NumberInputProps) {
  const showingValue = Math.floor(value || 0);
  return (
    <input
      type="number"
      onChange={onChange}
      value={showingValue}
      className="w-full h-9 px-3 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
      {...otherProps}
    />
  );
}

export default NumberInput;
